export var SliderStyles = function SliderStyles(props) {
  var disabled = props.disabled,
      theme = props.theme;
  var palette = theme.palette;
  return {
    activeSection: [disabled && {
      background: palette.neutralTertiary
    }]
  };
};